import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import VoucherCard from './VoucherCard';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Component = styled.div`
    display: flex;
    padding: 20px;
    justify-content: space-between;
    flex-direction: column;
    /*flex-wrap: wrap;*/
    background: rgb(238,174,202);
    background: radial-gradient(circle, 
                                rgba(238,174,202,1) 0%, 
                                rgba(148,187,233,1) 100%);
`
const Header = styled.h1`
    flex: 1;
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;
`

const Filter = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-left: 10px;
    margin-bottom: 10px;
`

const Input = styled.input`
    width: 50%;
    padding: 10px;
    font-size: 20px;
    border-radius: 5px;
`

const VoucherContainer = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
`

const SearchNotFound = styled.div`
    width: 50%;
    padding: 10px;
    color: red;
    font-size: 20px;
`

const ViewAllPVsLink = styled(Link)`
    text-align: center;
`

const ViewVouchers = ({limit}) => {

    const [searchFilter, setSearchFilter] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const [filterMsg, setFilterMsg] = useState('');
    const pv = useSelector(state => state.pv);
    
    const vouchers = [...pv?.vouchers];
    
    vouchers.reverse();
    //console.log(pv.vouchers);
    //console.log(vouchers);

    useEffect(() => {
        const filterData = vouchers?.filter((item) => (
            item.dept?.toLowerCase()?.includes(searchFilter.toLowerCase()) ||
                item.payee?.toLowerCase()?.includes(searchFilter.toLowerCase()) ||
                item.section?.toLowerCase()?.includes(searchFilter.toLowerCase()) ||
                item.location?.toLowerCase()?.includes(searchFilter.toLowerCase()) ||
                item.bank?.toLowerCase()?.includes(searchFilter.toLowerCase()) ||
                item.project?.toLowerCase()?.includes(searchFilter.toLowerCase()) ||
                item.acctno?.toString()?.includes(searchFilter) ||
                item.voucherNo?.toString()?.includes(searchFilter) ||
                item.voucherDateStr?.includes(searchFilter) ||
                item.totalAmount?.toString()?.includes(searchFilter)
        ));
        
        setFilteredData(filterData);
        
        searchFilter?.length > 0 
            ? setFilterMsg(`${filterData.length > 0 ? filterData.length : 'No'} Results Found`) 
            : setFilterMsg('');

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchFilter]);

    
    return (
        <Component>

        {
            limit ? <>
            <Header>
                Recent Payment Vouchers
            </Header>
            <ViewAllPVsLink to={'/vouchers'}>
                View All Payment Vouchers
            </ViewAllPVsLink>
            </> 
            : <Header>All Payment Vouchers</Header>
        }
        
        

        {!limit && 
        <Filter>
            <Input 
                placeholder='Search'
                onChange={(e) => setSearchFilter(e.target.value)}>
            </Input>
            <SearchNotFound>
                {filterMsg}
            </SearchNotFound> 
            
        </Filter>}
        <VoucherContainer>
        {!limit && filteredData && filteredData.length > 0 ? filteredData?.map((item, index) => (
            <VoucherCard key={item.voucherNo} 
                            voucher = {item}/>
        )) :
        !limit && vouchers?.map((item, index) => (
            <VoucherCard key={item.voucherNo} voucher = {item}/>
        ))
        }

        {limit && vouchers?.slice(0, limit).map((item, index) => (
            <VoucherCard key={item.voucherNo} voucher = {item}/>
        ))
        }

        </VoucherContainer>
        </Component>
    )
}

export default ViewVouchers
